import { useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import SideNav from "../SideNav";
import LaptopImg from "../../assets/png/4417111_browser_laptop_on_web_browsing_icon.png";
import TopNav from "../TopNav";
import { useSelector } from "react-redux";
import BottomNav from "../BottomNav";

const Layout = ({ children }) => {
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(false);
  const { role } = useSelector((state) => state.userDetails);
  useEffect(() => {
    // Function to check if the screen size is mobile
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth < 800); // You can adjust the width based on your requirement
    };

    if (role == "Sales Agent") {
      checkIsMobile();
    }
    // Initial check

    // Add event listener to update on resize
    window.addEventListener("resize", checkIsMobile);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("resize", checkIsMobile);
    };
  }, [role]);

  // Custom component for mobile view
  const MobileViewComponent = () => (
    <div className="flex items-center justify-center h-screen w-screen bg-white">
      <div className="bg-white p-3  ">
        <div className="p-2 flex flex-col items-center justify-center border rounded ">
          <div className="w-[100px] h-[100px] ">
            <img className="w-full h-full" src={LaptopImg} />
          </div>
          <p className="font-semibold text-center mt-3">
            Kindly use a laptop or a desktop, for a experience
          </p>
        </div>
      </div>
    </div>
  );

  if (isMobile) {
    return (
      <div className="h-screen w-screen bg-[#f1f0f0] overflow-y-scroll">
        <div className="sticky top-0 left-0 z-40">
          <TopNav />
        </div>
        <div className="px-4 pt-4 pb-20">{children}</div>
        <BottomNav />
      </div>
    );
  }

  return (
    <div className="h-screen w-screen z-40 fixed items-start top-0 md:flex lg:flex left-0">
      {location.pathname !== "/userroles" && <SideNav />}
      <div
        className="h-screen relative top-0 left-0 bg-[#f1f0f0] overflow-y-scroll"
        style={{
          width: "100%",
        }}
      >
        <div className="sticky top-0 left-0 z-40">
          <TopNav />
        </div>
        <div className="lg:px-4 pt-4 h-screen !z-50">{children}</div>
      </div>
    </div>
  );
};

export default Layout;
